// extracted by mini-css-extract-plugin
export default {"mainContainer":"CreatePackage_mainContainer__Xhhi7","backContainer":"CreatePackage_backContainer__ReExp","icon":"CreatePackage_icon__wi7p+","text":"CreatePackage_text__WZsEa"};